import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createAccountingPeriod } from './accountingPeriod';
import type { AccountingPeriod } from './accountingPeriod.types';
import {
  ACCOUNTING_PERIOD_METADATA_KEY,
  ACCOUNTING_PERIODS_KEY,
} from './constants';

export const useCreateAccountingPeriod = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createAccountingPeriod,
    onSuccess: (_newPeriod: AccountingPeriod) => {
      // Invalidate and refetch all accounting periods queries
      queryClient.invalidateQueries({ queryKey: [ACCOUNTING_PERIODS_KEY] });
      // Also invalidate metadata since new period affects counts
      queryClient.invalidateQueries({
        queryKey: [ACCOUNTING_PERIOD_METADATA_KEY],
      });
    },
  });
};
